/**
 * Helper function to remove properties with `undefined` values and lowercase strings
 * Recursively processes objects and arrays, converting all string values to lowercase
 * and removing any undefined properties.
 *
 * @param obj - The object to clean and convert to lowercase
 * @returns A new object with undefined values removed and strings converted to lowercase
 */
export const cleanAndLowercase = (
  obj: Record<string, any>
): Record<string, any> =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      if (typeof value === 'string') {
        acc[key] = value.toLowerCase();
      } else if (Array.isArray(value)) {
        acc[key] = value.map((item) => {
          if (typeof item === 'string') {
            return item.toLowerCase();
          }
          if (typeof item === 'object' && item !== null) {
            return cleanAndLowercase(item as Record<string, any>);
          }
          return item;
        });
      } else if (typeof value === 'object' && value !== null) {
        const cleanValue = cleanAndLowercase(value as Record<string, any>);
        if (Object.keys(cleanValue).length > 0) {
          acc[key] = cleanValue;
        }
      } else {
        acc[key] = value;
      }
    }
    return acc;
  }, {} as Record<string, any>);
